import { Accordion } from '@vwfs-bronson/bronson-react';
import React from 'react';

export type AccordionItemProps = {
    children?: React.ReactElement | React.ReactElement[];
    defaultOpen?: boolean;
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    titleLevel?: 2 | 3 | 4 | 5 | 6;
    icon?: string;
    tooltip?: string | React.ReactNode;
    testId?: string;
    contentClassName?: string;
    className?: string;
    titleSplit?: string | React.ReactNode;
    ariaLabel?: string;
};

export const AccordionItem: React.FC<AccordionItemProps> = ({
    defaultOpen,
    title,
    subtitle,
    titleLevel,
    icon,
    tooltip,
    testId,
    contentClassName,
    className,
    titleSplit,
    children,
    ariaLabel,
}) => {
    return (
        <Accordion.Item
            defaultOpen={defaultOpen}
            title={title}
            titleLevel={titleLevel}
            subtitle={subtitle}
            icon={icon}
            tooltip={tooltip}
            testId={testId}
            contentClassName={contentClassName}
            className={className}
            titleSplit={titleSplit}
            aria-label={ariaLabel}
        >
            {children}
        </Accordion.Item>
    );
};

AccordionItem.displayName = 'AccordionItem';
